module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-G-Video.2ba4c488.webp";